"use strict";
window.dataLayer = window.dataLayer || [];
let dataLayer = window.dataLayer;
// Create a new push method on the dataLayer object that extends its functionality to dispatch a custom event.
// Capture the original push method to be used in the new push method.
const originalPush = dataLayer.push.bind(dataLayer);
// Replace the original push method with a new one that dispatches a custom event.
dataLayer.push = (obj) => {
    // Call the original push method.
    originalPush(obj);
    // Dispatch a new custom event named "dataLayer.push" with the obj argument as the detail property of the event.
    window.dispatchEvent(new CustomEvent('dataLayer.push', { detail: obj }));
};
